module.exports = __webpack_public_path__ + "img/picture_viptk01.3d8d97ec.png";